var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 5V4.2C14.0996 3.0799 14.0996 2.51984 13.8816 2.09202C13.6899 1.71569 13.3839 1.40973 13.0076 1.21799C12.5798 1 12.0197 1 10.8996 1H9.29961C8.1795 1 7.61945 1 7.19163 1.21799C6.8153 1.40973 6.50934 1.71569 6.3176 2.09202C6.09961 2.51984 6.09961 3.0799 6.09961 4.2V5M1.09961 5H19.0996M17.0996 5V16.2C17.0996 17.8802 17.0996 18.7202 16.7726 19.362C16.485 19.9265 16.0261 20.3854 15.4616 20.673C14.8198 21 13.9798 21 12.2996 21H7.89961C6.21945 21 5.37937 21 4.73764 20.673C4.17315 20.3854 3.71421 19.9265 3.42659 19.362C3.09961 18.7202 3.09961 17.8802 3.09961 16.2V5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.0aa977293edf3b9b472288c470a25c84.svg";
export { ForwardRef as ReactComponent };